import DayTime from "./rightpanel/DayTime.jsx";
import LayerList from "./rightpanel/Layerlist.jsx";
import Measure from "./rightpanel/Measure.jsx";
import UploadBuilding from "./rightpanel/uploadbuilding/UploadBuilding.jsx";
import ViewAnalyse from "./rightpanel/ViewAnalyse.jsx";
import ViewPoints from "./rightpanel/ViewPoints.jsx";
import Weather from "./rightpanel/Wether.jsx";
import texts from "../assets/texts/texts.js";
import ProjektList from "./rightpanel/uploadbuilding/ProjectList.jsx";

function Widgets({ projectListInput, setProjectListInput }) {
  return [
    {
      objekt: () => <LayerList />,
      icon: "layers",
      label: texts.widgets.layerlist.title,
      descriptionsURL: texts.widgets.layerlist.descriptionsURL,
    },
    {
      objekt: () => <ProjektList projectListInput={projectListInput} />,
      icon: "organization",
      label: texts.widgets.uploadmodel.projekts.title,
      descriptionsURL: texts.widgets.uploadmodel.projekts.descriptionsURL,
    },
    {
      objekt: () => (
        <UploadBuilding setProjectListInput={setProjectListInput} />
      ),
      icon: "upload",
      label: texts.widgets.uploadmodel.title,
      descriptionsURL: texts.widgets.uploadmodel.descriptionsURL,
    },

    {
      objekt: () => <ViewAnalyse />,
      icon: "line-of-sight",
      label: texts.widgets.viewanalyse.title,
      descriptionsURL: texts.widgets.viewanalyse.descriptionsURL,
    },
    {
      objekt: () => <ViewPoints />,
      icon: "view-visible",
      label: texts.widgets.viewpoints.title,
      descriptionsURL: texts.widgets.viewpoints.descriptionsURL,
    },
    {
      objekt: () => <DayTime />,
      icon: "date-time",
      label: texts.widgets.daytime.title,
      descriptionsURL: texts.widgets.daytime.descriptionsURL,
    },
    {
      objekt: () => <Weather />,
      icon: "partly-cloudy",
      label: texts.widgets.weather.title,
      descriptionsURL: texts.widgets.weather.descriptionsURL,
    },
    {
      objekt: () => <Measure />,
      icon: "measure",
      label: texts.widgets.measure.title,
      descriptionsURL: texts.widgets.measure.descriptionsURL,
    },
  ];
}

export default Widgets;
